var render = function render(_c,_vm){return _c('div',{staticClass:"v-loader-button"},_vm._l((3),function(item){return _c('div',{staticClass:"v-loader-button__icon"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }